










import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  data() {
    return {
      isUnderMaintenance: true,
    }
  },
  computed: {
    date() {
      moment.locale(this.$store.getters.profile.lang)
      return moment('2021-01-04').format('dddd, MMMM DD YYYY')
    },
  },
})
